import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

// Components
import { If } from '../../../../deprecated/Conditionals'
import CospoIntro from '../CospoIntro'
import RefiVideo from './RefiVideo'
import SyndicatedVideo from './SyndicatedVideo'

// Selectors
import {
  selectRefi30FixedVideoId,
  selectRefi30FixedVideoType,
  selectRefi30FixedVideoSyndicated,
} from '../../../../store/selectors/videos'
import { selectCustomerHasSponsor } from '../../../../store/selectors/customerProfile'

const RefiDetailsVideo = ({ footerId }) => {
  const videoId = useSelector(selectRefi30FixedVideoId)
  const videoType = useSelector(selectRefi30FixedVideoType)
  const hasSyndicatedVideo = useSelector(selectRefi30FixedVideoSyndicated)
  const hasSponsor = useSelector(selectCustomerHasSponsor)

  return (
    <>
      <If condition={videoId && videoType}>
        {hasSyndicatedVideo && hasSponsor ? (
          <SyndicatedVideo
            videoId={videoId}
            videoType={videoType}
            footerId={footerId}
          />
        ) : (
          <RefiVideo videoId={videoId} videoType={videoType} />
        )}
      </If>
      <If condition={!videoId && hasSponsor}>
        <CospoIntro footerId={footerId} />
      </If>
    </>
  )
}

RefiDetailsVideo.propTypes = {
  footerId: PropTypes.string,
}
export default RefiDetailsVideo
